import Bouncer from 'components/Common/Bouncer';
import React, { memo, useContext } from 'react';
import {
  CurrentQuestionsContext,
} from 'components/CleanRooms/CurrentQuestions/CurrentQuestionsContextProvider';
import { DropdownMenu, HButton } from 'BaseComponents';
import { IdContext } from 'pages/CleanRooms/QuestionDetails';
import { Link, useHistory } from 'react-router-dom';
import { ResizableContext } from 'BaseComponents/HDataTable/ResizableContextProvider';
import { Stack } from '@mui/material';
import { cleanRoom } from 'utils/spaUrls';
import { cleanRoomPermissions } from 'utils/appConstants';


const QuestionsActionButton = memo(({ row }) => {
  const history = useHistory();
  const { crId } = useContext(IdContext);
  const { tableBodyElement } = useContext(ResizableContext);

  const {
    getReportMenuItems,
    getReportBtnTooltipTitle,
  } = React.useContext(CurrentQuestionsContext);

  return (
    <Stack direction='row' spacing={1}>
      <Bouncer allowList={[cleanRoomPermissions.manageDatasets]}>
        <HButton
          size='small'
          data-testid='current-question-manage-dataset-button'
          component={Link}
          to='#'
          onClick={() => history.push(cleanRoom.assignDatasetsWizard(crId, row.ID))}
          variant='outlined'
        >
          Assign Datasets
        </HButton>
      </Bouncer>
      <DropdownMenu
        label='Report'
        variant='contained'
        color='secondary'
        menuItems={getReportMenuItems(row)}
        tooltipTitle={getReportBtnTooltipTitle(row)}
        htmlContainerEl={tableBodyElement.current}
      />
    </Stack>
  );
});

export default QuestionsActionButton;
